import { strapiClient } from "@shared/api";
import rebuild from "@shared/api/rebuild";

import { mapDtoToCafesRestaurantsPoints } from "../model";
import type { CafesRestaurantsPoints } from "../model/types";

const parseCombinedFilter = (filter: string) => {
  const parts = (filter || "all")
    .split("&")
    .map((p) => p.trim())
    .filter(Boolean);

  const badgesPart = parts.find((p) => p.startsWith("badges="));
  const badges = badgesPart
    ? badgesPart
        .replace("badges=", "")
        .split(",")
        .map((x) => x.trim())
        .filter(Boolean)
    : [];

  const badgesExcludePart = parts.find((p) => p.startsWith("badges_exclude="));

  const badgesExclude = badgesExcludePart
    ? badgesExcludePart
        .replace("badges_exclude=", "")
        .split(",")
        .map((x) => x.trim())
        .filter(Boolean)
    : [];

  const tabUid =
    parts.find(
      (p) => !p.startsWith("badges=") && !p.startsWith("badges_exclude="),
    ) || "all";

  return { tabUid, badges, badgesExclude };
};

export const getCurrentCafesRestaurantsPoint = async (
  cafesRestaurantsType: string,
  pageCount: number,
) => {
  const { tabUid, badges, badgesExclude } =
    parseCombinedFilter(cafesRestaurantsType);

  const andFilters: Array<Record<string, unknown>> = [];

  if (tabUid !== "all") {
    andFilters.push({
      cafes_restaurants_types: {
        uid: {
          $in: [tabUid],
        },
      },
    });
  }

  // New logic: include points that have ANY selected badge.
  if (badges.length > 0) {
    andFilters.push({
      cafes_restaurants_badge_types: {
        uid: {
          $in: badges,
        },
      },
    });
  } else if (badgesExclude.length > 0) {
    // Backward compatibility: exclude points that have ANY excluded badge.
    // This also keeps points with no badges in the relation.
    andFilters.push({
      $not: {
        cafes_restaurants_badge_types: {
          uid: {
            $in: badgesExclude,
          },
        },
      },
    });
  }

  const filters = andFilters.length > 0 ? { $and: andFilters } : {};

  const searchParams = {
    sort: ["createdAt:desc"],
    pagination: {
      page: pageCount || 1,
      pageSize: 6,
    },
    filters: { ...filters },
    populate: {
      photos: {
        populate: "*",
      },
      cafes_restaurants_types: {
        populate: "*",
      },
      cafes_restaurants_badge_types: {
        populate: "*",
      },
      workTimeList: {
        populate: "*",
      },
    },
  };

  const cafesRestaurantsPoints = strapiClient.collection(
    "cafes-restaurants-points",
  );

  const points = await cafesRestaurantsPoints.find({
    ...searchParams,
  });

  return rebuild(
    mapDtoToCafesRestaurantsPoints(points),
  ) as CafesRestaurantsPoints;
};
